const palette = {
  text: {
    primary: '#020537DE',
    secondary: '#0205378A',
    disabled: '#02053742',
    hover: '#0205370A',
    selected: '#02053714',
    focus: '#0205371F',
    focusVisible: '#0205374D',
  },
  textLight: {
    primary: '#FFFFFF',
    secondary: '#FFFFFFCC',
    disabled: '#FFFFFF99',
  },
  primary: {
    dark: '#93005A',
    main: '#DA006D',
    light: '#FFE0EA',
    hover: '#FF00800A',
    selected: '#FF008014',
    focus: '#FF00801F',
    focusVisible: '#FF00804D',
    outlinedBorder: '#DA006D52',
  },
  secondary: {
    900: '#020537',
    800: '#010764',
    700: '#040A67',
    dark: '#050D80',
    500: '#060F98',
    main: '#2E35A8',
    300: '#565CB9',
    200: '#7E82C9',
    100: '#A5A9DA',
    light: '#D9DBFA',
    hover: '#2E35A80A',
    selected: '#2E35A814',
    focus: '#2E35A81F',
    focusVisible: '#2E35A84D',
    outlinedBorder: '#2E35A852',
  },
  error: {
    dark: '#C62828',
    main: '#F44336',
    light: '#EF5350',
    outlinedBorder: '#D32F2F80',
  },
  warning: {
    dark: '#E65100',
    main: '#FF9800',
    light: '#FFF4E5',
    outlinedBorder: '#EF6C0080',
  },
  info: {
    dark: '#0D47A1',
    main: '#2196F3',
    light: '#E5F6FD',
    outlinedBorder: '#42A5F580',
  },
  success: {
    dark: '#1B5E20',
    main: '#4CAF50',
    light: '#EDF7ED',
    outlinedBorder: '#2E7D3280',
  },
  grey: {
    50: '#F5F6FA',
    400: '#878CA8',
    500: '#5D6688',
    600: '#414B67',
    700: '#28324D',
  },
  background: {
    backdrop: '#02053766',
    default: '#F7F4EE',
    base: '#FEFDFD',
  },
  common: {
    absencePlannerDay: '#FFF2F6', // TODO: remove when updating absence planner colors to new design
    absencePlannerSelectedDay: '#f2f4f9', // TODO: remove when updating absence planner colors to new design
    absencePlannerNewMonth: '#f2f2f2', // TODO: remove when updating absence planner colors to new design
    divider: '#0205371F',
    dividerDark: '#141A3333',
    transparent: 'transparent',
    white: '#FFFFFF',
  },
}

export default palette
